export default "__VITE_ASSET__2a246a76__"